<app-alert
  style="margin-bottom: 40px"
  class="flex-col-container mt-32"
  type="warning"
  icon="warning_amber"
  lineHeight="lh-1"
  [message]="'MODAL_CARDS_RESTART_RESEND.ALERT' | translate  ">
</app-alert>
